"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rules_1 = require("./rules");
var addresses_1 = require("./addresses");
var create = function (network) {
    var addresses = network === "mainnet" ? addresses_1.mainnet : addresses_1.testnet;
    var rules = (0, rules_1.createMirrorRules)(addresses);
    var openPositionRuleSet = {
        rule: rules.openPosition,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/open-position",
            canonicalMsg: [
                "Deposit ".concat(matched[4].value, " (Position ID: ").concat(matched[0], ")"),
                "Mint ".concat(matched[3].value),
            ],
            payload: fragment,
        }); },
    };
    var depositRuleSet = {
        rule: rules.depositRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/deposit",
            canonicalMsg: [
                "Deposit ".concat(matched[3].value, " (Position ID: ").concat(matched[2].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var withdrawRuleSet = {
        rule: rules.withdrawRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/withdraw",
            canonicalMsg: [
                "Withdraw ".concat(matched[3].value, " (Position ID: ").concat(matched[2].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var burnRuleSet = {
        rule: rules.burnRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/burn",
            canonicalMsg: [
                "Burn ".concat(matched[8].value, " (Position ID: ").concat(matched[7].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var stakeLPRuleSet = {
        rule: rules.stakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/stake-LP",
            canonicalMsg: ["Stake ".concat(matched[8].value).concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSet = {
        rule: rules.unstakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unstake-LP",
            canonicalMsg: ["Unstake ".concat(matched[8].value).concat(matched[4].value)],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSetTypeB = {
        rule: rules.unstakeLPRuleTypeB,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unstake-LP",
            canonicalMsg: ["Unstake ".concat(matched[9].value).concat(matched[5].value)],
            payload: fragment,
        }); },
    };
    var lpStakingRewardRuleSet = {
        rule: rules.lpStakingRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/LP-staking-reward",
            canonicalMsg: ["Claim Reward ".concat(matched[7].value).concat(matched[3].value)],
            payload: fragment,
        }); },
    };
    var govStakeRuleSet = {
        rule: rules.govStakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/governance-stake",
            canonicalMsg: [
                "Stake ".concat(matched[4].value).concat(matched[0].value, " to ").concat(matched[5].value),
            ],
            payload: fragment,
        }); },
    };
    var govUnstakeRuleSet = {
        rule: rules.govUnstakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/governance-unstake",
            canonicalMsg: [
                "Unstake ".concat(matched[3].value).concat(matched[4].value, " to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var createPollRuleSet = {
        rule: rules.createPollRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/create-poll",
            canonicalMsg: ["Create Poll (Poll ID: ".concat(matched[8].value, ")")],
            payload: fragment,
        }); },
    };
    var castVoteRuleSet = {
        rule: rules.castVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/cast-vote",
            canonicalMsg: [
                "Vote to Poll (Poll ID: ".concat(matched[2].value, ") (").concat(matched[5].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var airdropRuleSet = {
        rule: rules.airdropRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/airdrop",
            canonicalMsg: ["Claim ".concat(matched[4].value).concat(matched[5].value)],
            payload: fragment,
        }); },
    };
    var buySubmitOrderRuleSet = {
        rule: rules.buySubmitOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/submit-order-buy",
            canonicalMsg: [
                "Order to buy ".concat(matched[5].value, " with ").concat(matched[4].value),
            ],
            payload: fragment,
        }); },
    };
    var sellSubmitOrderRuleSet = {
        rule: rules.sellSubmitOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/submit-order-sell",
            canonicalMsg: [
                "Order to sell ".concat(matched[9].value, " for ").concat(matched[10].value),
            ],
            payload: fragment,
        }); },
    };
    var cancelOrderRuleSet = {
        rule: rules.cancelOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/cancel-order",
            canonicalMsg: ["Canceled limit order ID:".concat(matched[2].value)],
            payload: fragment,
        }); },
    };
    var buyExecuteOrderRuleSet = {
        rule: rules.buyExecuteOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/execute-order-buy",
            canonicalMsg: ["Bought ".concat(matched[9].value, " with ").concat(matched[8].value)],
            payload: fragment,
        }); },
    };
    var sellExecuteOrderRuleSet = {
        rule: rules.sellExecuteOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/execute-order-sell",
            canonicalMsg: ["Sold ".concat(matched[3].value, " for ").concat(matched[4].value)],
            payload: fragment,
        }); },
    };
    var lpStakeRuleSet = {
        rule: rules.longFarm,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/LP-stake",
            canonicalMsg: ["Stake LP to ".concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var borrowRuleSet = {
        rule: rules.borrow,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/borrow",
            canonicalMsg: ["Mint ".concat(matched[3].value, " with ").concat(matched[4].value)],
            payload: fragment,
        }); },
    };
    var unlockAmountRuleSet = {
        rule: rules.unlockAmount,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unlock-amount",
            canonicalMsg: ["Unlock ".concat(matched[2].value)],
            payload: fragment,
        }); },
    };
    return [
        openPositionRuleSet,
        depositRuleSet,
        withdrawRuleSet,
        burnRuleSet,
        stakeLPRuleSet,
        unstakeLPRuleSet,
        unstakeLPRuleSetTypeB,
        lpStakingRewardRuleSet,
        govStakeRuleSet,
        govUnstakeRuleSet,
        createPollRuleSet,
        castVoteRuleSet,
        airdropRuleSet,
        buySubmitOrderRuleSet,
        sellSubmitOrderRuleSet,
        cancelOrderRuleSet,
        buyExecuteOrderRuleSet,
        sellExecuteOrderRuleSet,
        lpStakeRuleSet,
        borrowRuleSet,
        unlockAmountRuleSet,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map